import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import SaveTwoToneIcon from "@mui/icons-material/SaveTwoTone";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import DoneIcon from "@mui/icons-material/Done";
import AddIcon from "@mui/icons-material/Add";

import {
  ONCHANGE_QUYTRINH_KETQUA,
  ONCHANGE_DELETE_QUYTRINH_KETQUA,
  ONPUSH_KETQUA,
} from "../../../redux/reducers/workingReducer/_index";

import { onTouchForm } from "../../../funcs/onTochForm";

const EditKetqua = (props: any) => {
  const handleClose = props.handleClose;
  const taskId = props.taskId;

  const selectedKetQuaList = props.selectedKetQuaList;
  const _onChangeKetqua = props._onChangeKetqua;
  const _onPushKetqua = props._onPushKetqua;
  const _onDeleteKetqua = props._onDeleteKetqua;
  const _onChangeStepList = props._onChangeStepList;
  const ketqua = props.ketqua;

  const data = useSelector((state: any) => state.workingReducer);
  const dispatch = useDispatch();

  const [quytrinhName, setQuytrinhName] = useState<any>("");
  const [stepList, setStepList] = useState<any[] | null>(null);
  const [resultList, setResultList] = useState<any[] | null>(null);

  const [newNameKetqua, setNewNameStep] = useState<string | null>(null);

  const _onClickPushKetqua = () => {
    const body = {
      tenketqua: newNameKetqua,
      idquytrinh: taskId,
    };

    dispatch(ONPUSH_KETQUA(body));
  };

  // funcs

  return (
    <div
      className="
      lg:w-[40rem] w-screen h-[37rem] bg-white rounded-md
      flex flex-col
    "
    >
      {/* header */}
      <div
        className="
      flex items-center pl-4 pr-4
      text-white font-semibold
      bg-sky-500 w-full h-[3rem]
      rounded-t-md text-lg justify-between
    "
      >
        <p>Sửa kết quả</p>
        <button
          className="hover:bg-slate-300 pl-2 pr-2 rounded-full"
          onClick={handleClose}
        >
          X
        </button>
      </div>

      {/* content */}
      <div
        className="
        flex flex-col p-4 w-full h-[calc(100%-6rem)]
        text-sm
        space-y-3
      "
      >
        <div className="flex flex-col w-full h-max">
          <label>Nội dung kết quả</label>
          <div className="flex w-full h-max justify-between">
            <textarea
              className="w-1/2 h-[1.9rem] rounded-md pl-2 pr-2 border-2 border-slate-200"
              placeholder="Nhập nội dung kết quả"
              value={ketqua}
              onChange={(e: any) => _onChangeKetqua(e)}
              onTouchStart={(e: any) => onTouchForm(e)}
            />
            <div className="flex pl-3 items-center justify-end w-1/5 h-max">
              {/* <label className="text-white">Cập nhật</label> */}
              <button
                className="flex pt-1 pb-1 pr-2 pl-2 h-[1.9rem] bg-green-500 text-white rounded-md hover:bg-green-400"
                onClick={_onPushKetqua}
              >
                <AddIcon fontSize="small" />
                <p>Thêm</p>
              </button>
            </div>
          </div>
        </div>

        {/* here */}
        <div className="tableModal styled-scrollbars w-full h-[20rem] shadow-md">
          <table>
            <thead className="text-white font-semibold text-center w-full h-[2rem]">
              <tr>
                <th className="border-l-[1px] border-slate-300">STT</th>
                <th className="border-l-[1px] border-slate-300">
                  Nội dung kết quả
                </th>
                <th className="border-l-[1px] border-r-[1px] border-slate-300">
                  Xoá
                </th>
              </tr>
            </thead>
            <tbody className="w-full h-[calc(100%-2rem)] bg-white overflow-auto">
              {selectedKetQuaList === null ? (
                <></>
              ) : (
                selectedKetQuaList.map((item: any, index: any) => (
                  <tr key={index} className="w-max h-[2rem] bg-white">
                    <td className="text-center border border-slate-300">
                      <p>{index + 1}</p>
                    </td>
                    <td className="text-center border border-slate-300">
                      <textarea
                        className="w-full h-max rounded-md pl-2 pt-1 pb-1 pr-2 border-2 border-slate-200 text-black"
                        value={item.tenketqua}
                        onChange={(e: any) => {
                          _onChangeStepList("result", e.target.value, index);
                        }}
                        onTouchStart={(e: any) => onTouchForm(e)}
                      />
                    </td>
                    <td className="text-center border border-slate-300">
                      <div className="flex justify-center items-center w-full h-full">
                        <button
                          className="text-red-500 w-max h-max flex text-center hover:text-red -300"
                          onClick={() => _onDeleteKetqua(item.tenketqua)}
                        >
                          <DeleteTwoToneIcon fontSize="small" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* footer */}
      <div
        className="
        flex items-center justify-end w-full h-[3rem] bg-slate-100 rounded-b-md space-x-4 text-sm
        pl-4 pr-4
      "
      >
        <button
          className="flex bg-green-500 text-white pt-1 pb-1 pr-2 pl-2 rounded-md hover:bg-green-400"
          onClick={handleClose}
        >
          <DoneIcon fontSize="small" />
          <p>Xác nhận</p>
        </button>
        <button
          className="bg-slate-300 text-white pt-1 pb-1 pr-2 pl-2 rounded-md hover:bg-slate-200"
          onClick={handleClose}
        >
          Đóng
        </button>
      </div>
    </div>
  );
};

export default EditKetqua;
